import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const AlgorithmsAndDataStructuresFundamentals = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Importance and Fundamentals of Algorithms and Data Structures"
    videos={[
      "https://www.youtube.com/embed/jOMxKsUd6e0"
    ]}
    takeaways={[
      { text: "If you wish to get good placement, never treat DSA as just a semester subject; truly understand and master the concepts." },
      { text: "Learn data structures from high-quality sources (e.g., Strivers, etc.)." },
      { text: "DSA exam question papers are lengthy—time management is critical! Practice to build speed for exams." }
    ]}
    questions={[
      "What do you mean by a good algorithm"
    ]}
    exampleVideos={[]}
  />
);
}

export default AlgorithmsAndDataStructuresFundamentals;
